import React from "react";
import HtmlContent from "./HTMLContent";

interface BonusCardProps {
  index: number;
  logo: string;
  contentName: string;
  category: string;
  refURL: string;
  bonusCode?: string;
  description?: string;
}

const BonusCard = (props: BonusCardProps) => {
  const { logo, description, contentName, category, bonusCode, refURL, index } =
    props;

  return (
    <a
      key={index}
      href={refURL}
      className="flex flex-col bg-white/30 rounded-lg shadow md:flex-row md:max-w-2xl"
    >
      <img
        className="object-fit w-full rounded-t-lg h-96 md:h-56 md:w-56 md:rounded-none md:rounded-s-lg"
        src={logo}
        alt="Preview"
      />
      <div className="flex flex-col justify-between p-4 leading-normal text-gray-300">
        <div className="flex flex-col">
          <h5 className="mb-2 text-2xl font-bold tracking-tight">
            {contentName} <span className="text-sm ml-2">(click me)</span>
          </h5>
          <h5 className="mb-2 text-md font-bold tracking-tight ">
            <b>Bonus Type :</b>
            <span className="text-md ml-3 font-normal">{category}</span>
          </h5>
        </div>

        {bonusCode && (
          <h5 className="mb-2 text-xl font-bold tracking-tight ">
            <b>Bonus Code :</b>{" "}
            <span className="text-md ml-3 font-normal">{bonusCode}</span>
          </h5>
        )}
        {description && <HtmlContent htmlString={description} />}
      </div>
    </a>
  );
};

export default BonusCard;
